import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsappButton.css";

export default function WhatsappButton() {
  const phoneNumber = "9840693733"; // Replace with your number
  const message = "Thank you for contacting ourcountry ourpeople foundation!Please let us know how we can help you"; // Optional pre-filled message
  const whatsappLink = `https://wa.me/${phoneNumber.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <FaWhatsapp size={28} />
    </a>
  );
}
